import React from 'react';
import { styled } from '@linaria/react';

import useToggle from '@/hooks/use-toggle';

import PolarAmountVisualization from './PolarAmountVisualization';

const useAnimatedPolarity = () => {
  const [isPolar, setIsPolar] = React.useState(true);

  React.useEffect(() => {
    let timeoutId: number;

    const update = () => {
      setIsPolar((isPolar) => !isPolar);

      timeoutId = window.setTimeout(update, 1600);
    };

    update();

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, []);

  return isPolar;
};

interface Props {
  isPoweredOn: boolean;
  prefersReducedMotion: boolean;
  width?: number;
  height?: number;
  padding?: number;
}

const LoadingPolar = ({
  isPoweredOn,
  prefersReducedMotion,
  width = 36,
  height = 38,
  padding = 2,
}: Props) => {
  const [hasBegun, toggleBegun] = useToggle(false);

  const isPolar = useAnimatedPolarity();

  React.useEffect(() => {
    if (!isPoweredOn) {
      toggleBegun(false);
      return;
    }

    const timeoutId = window.setTimeout(() => {
      toggleBegun();
    }, 200);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isPoweredOn, toggleBegun]);

  return (
    <Wrapper style={{ padding }}>
      <Visualization
        style={{
          opacity: hasBegun ? 1 : 0,
          transition: 'opacity 350ms',
          // HACK HACK HACK
          // centering because with such low `numOfPointsPerLine`, it doesnt
          // appear centered by default
          transform: isPolar ? 'translateX(0)' : 'translateX(1px)',
        }}
      >
        <PolarAmountVisualization
          width={width - padding * 2}
          height={height - padding * 2}
          horizontalPadding={0}
          verticalPadding={0}
          numOfLines={5}
          value={isPolar ? 100 : 0}
          prefersReducedMotion={prefersReducedMotion}
          springConfig={{
            tension: 40,
            friction: 18,
          }}
        />
      </Visualization>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  border-radius: 4px;
  background: #2b2b2b;
`;

const Visualization = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export default LoadingPolar;
